/*
 * Precompro Pay para el checkout de domicilios: número, vencimiento y CVC se escriben en el iframe
 * de pay.precompro.com y el componente solo recibe un token (Wompi) o un sobre cifrado (PayU).
 * Copia del patrón de `select/src/mixins/pagoConIframe.js`.
 *
 * Se prende por ambiente con `VUE_APP_PAY_ORIGIN` Y cuando el restaurante tiene `precomproPublicId`
 * (lo da `marketplace/client/vendor/*`). Sin alguno de los dos, `usaPay` es false y cada componente
 * muestra su formulario de siempre.
 *
 * Uso: `mixins: [pagoConIframe]`, un `<div ref="payTarjeta">` en el template (con `v-if="usaPay"`) y,
 * cuando ese div ya existe, `this.montarPay('wompi' | 'payu', styleFrom)`.
 * Al pagar: `this.tokenizarTarjeta(titular)` → token (Wompi) o sobre `pp1.…` (PayU).
 */
import PrecomproPay from '@/helpers/precomproPay';

export default {
  data () {
    return {
      pay: null,
      payValido: false,
      payError: null
    };
  },
  computed: {
    // El publicId OPACO del vendor de Precompro del restaurante (no el id numerico).
    payPublicId () {
      const vendor = this.$store.getters.getVendor || {};
      return (this.order && this.order.vendor && this.order.vendor.precomproPublicId) || vendor.precomproPublicId || null;
    },
    usaPay () {
      return !!process.env.VUE_APP_PAY_ORIGIN && !!this.payPublicId;
    }
  },
  beforeDestroy () {
    if (this.pay) this.pay.destroy();
  },
  methods: {
    // `styleFrom`: un input del propio formulario; el iframe copia su aspecto real, asi queda
    // igual en cada restaurante sin configurar nada.
    montarPay (provider, styleFrom) {
      if (!this.usaPay || !this.$refs.payTarjeta) return;
      // Si el contenedor se volvio a pintar, el iframe viejo ya no esta en el DOM: se suelta y se monta otro.
      if (this.pay) {
        // `childElementCount`, no `querySelector('iframe')`: mientras carga, o si no pudo cargar,
        // lo que hay es el aviso del SDK (con su boton Reintentar) y montar otro lo duplicaria.
        if (this.$refs.payTarjeta.childElementCount) return;
        this.pay.destroy();
        this.pay = null;
      }
      this.pay = PrecomproPay.mount(this.$refs.payTarjeta, {
        origin: process.env.VUE_APP_PAY_ORIGIN,
        vendor: this.payPublicId,
        provider,
        styleFrom,
        onState: ({ valid }) => {
          this.payValido = valid;
          if (valid) this.payError = null;
        },
        onError: ({ message }) => {
          this.payError = message;
        }
      });
    },
    // El token/sobre es de un solo uso: se pide en cada intento de pago, justo antes de cobrar.
    // Devuelve `{ token, brand, last4 }`; si falla deja el error en `payError` y rechaza.
    tokenizarTarjeta (holder) {
      this.payError = null;
      return this.pay.tokenize({ holder: holder || '' })
        .catch((err) => {
          this.payError = (err && err.message) || 'No pudimos validar la tarjeta. Intenta de nuevo.';
          throw err;
        });
    }
  }
};
